export enum ActionTypes {
    PUT_RULER = "PUT_RULER",
    REMOVE_RULER = "REMOVE_RULER",
    PUT_GRIDS = "PUT_GRIDS",
    REMOVE_GRIDS = "REMOVE_GRIDS",
    CHANGE_NUM_GRIDS = "CHANGE_NUM_GRIDS",
    CHANGE_COLOR_GRIDS = "CHANGE_COLOR_GRIDS",
    CHANGE_GAP_GRIDS = "CHANGE_GAP_GRIDS",
    CHANGE_WIDTH_GRIDS = "CHANGE_WIDTH_GRIDS",
    PUT_CARD_IS_DRAG = "PUT_CARD_IS_DRAG",
    REMOVE_CARD_IS_DRAG = "REMOVE_CARD_IS_DRAG",
    PUT_COLUMN_IS_DRAG = "PUT_COLUMN_IS_DRAG",
    REMOVE_COLUMN_IS_DRAG = "REMOVE_COLUMN_IS_DRAG",
    PUT_ITEM_IS_DRAG = "PUT_ITEM_IS_DRAG",
    REMOVE_ITEM_IS_DRAG = "REMOVE_ITEM_IS_DRAG",
    MAKE_EDITABLE = "MAKE_EDITABLE",
    MAKE_UNEDITABLE = "MAKE_UNEDITABLE",
    REDACTOR_IS_OPEN = "REDACTOR_IS_OPEN",
    REDACTOR_IS_CLOSE = "REDACTOR_IS_CLOSE",
    SET_DESKTOP_VIEWPORT = "SET_DESKTOP_VIEWPORT",
    SET_MOBILE_VIEWPORT = "SET_MOBILE_VIEWPORT",
    CHANGE_REDEFINE_FONTS = "CHANGE_REDEFINE_FONTS",
    CHANGE_FONT_PAGE = "CHANGE_FONT_PAGE",
    HIDE_OPENED_WINDOW = "HIDE_OPENED_WINDOW",
    SHOW_WINDOW = "SHOW_WINDOW",
    CHANGE_CODE_HEAD_PAGE = "CHANGE_CODE_HEAD_PAGE",
    ADD_CODE_HEAD_PAGE = "ADD_CODE_HEAD_PAGE",
    DELETE_CODE_HEAD_PAGE = "DELETE_CODE_HEAD_PAGE",

    CHANGE_CODE_BODY_PAGE = "CHANGE_CODE_BODY_PAGE",
    ADD_CODE_BODY_PAGE = "ADD_CODE_BODY_PAGE",
    DELETE_CODE_BODY_PAGE = "DELETE_CODE_BODY_PAGE",

    CHANGE_ARRAY_CODE_BODY_PAGE = "CHANGE_ARRAY_CODE_BODY_PAGE",
    CHANGE_ARRAY_CODE_HEAD_PAGE = "CHANGE_ARRAY_CODE_HEAD_PAGE",
}
